'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.search.js
// module id = 613
// module chunks = 0